/* eslint-disable @typescript-eslint/naming-convention */
export enum HTML_TAGS {
  BUTTON = 'button',
  A = 'a',
}
